// extracted by mini-css-extract-plugin
export var barContainer = "_2c-0";
export var extraThin = "_2c-3";
export var fillBar = "_2c-6";
export var fillContainer = "_2c-4";
export var overflow = "_2c-8";
export var overflowContainer = "_2c-5";
export var regular = "_2c-7";
export var thick = "_2c-1";
export var thin = "_2c-2";